import React, { Component, useState, useEffect, useRef } from 'react';
import { Navbar, Container, Nav, Badge, Dropdown, Button } from 'react-bootstrap';
import { FolderService } from '../../services/FolderService'
import { UserService } from '../../services/UserService'
import { GlobalContext } from "../../services/GlobalProvider";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router";
import ErrorManager from "../../components/error-manager/ErrorManager";
import { BrouillonService } from '../../services/BrouillonService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import Pagination from '../../components/pagination/Pagination';
import { getFormErrorMsg, currencyFormat, granted } from '../../helper/Helper'


const Brouillons = ({ brouillonTypes, openBrouillon }) => {

  const [globalError, setGlobalError] = useState()
  const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
  
  const [brouillonsUser, setBrouillonsUser] = useState()
  const [brouillonsOther, setBrouillonsOther] = useState()
  const [currentUserPagination, setCurrentUserPagination] = useState(1)
  const [currentOtherPagination, setCurrentOtherPagination] = useState(1)

  const { globalContextLoaded, userDetails, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  const navigate = useNavigate();
  
    let brouillonsUserParams = useRef({
      'start': 0,
      'limit': 5,
      'filters': {
        'filter[type]': [{ operator: "=", value: brouillonTypes }]
      }
    });

  let brouillonsOtherParams = useRef({
    'start': 0,
    'limit': 5,
    'filters': {
      'filter[type]': [{ operator: "=", value: brouillonTypes }]
    }
  });

  useEffect(() => {
    if (globalContextLoaded) {
      brouillonsUserParams.current['filters']['filter[user]'] = [{ operator: "=", value: userDetails.preferred_username }]
      brouillonsOtherParams.current['filters']['filter[user]'] = [{ operator: "!=", value: userDetails.preferred_username }]
      getBrouillons()
    }
  }, [globalContextLoaded]);

  function getBrouillons(){
    if(granted(grants, "brouillons.consult")){
      getUserBrouillons()
    }
    if(granted(grants, "brouillons.consult.brouillons_tiers")){
      getOtherBrouillons()
    }
  }

  function getUserBrouillons() {
    BrouillonService.getBrouillons(folderDetails?.dossier?._id, brouillonsUserParams.current).then(res => {
      setBrouillonsUser(res.data.data)
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function getOtherBrouillons() {
    BrouillonService.getBrouillons(folderDetails?.dossier?._id, brouillonsOtherParams.current).then(res => {
      setBrouillonsOther(res.data.data)
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function removeUserBrouillon(brouillonId) {
    BrouillonService.removeBrouillon(folderDetails?.dossier?._id, brouillonId).then(res => {
      getUserBrouillons()
      setConfirmDialog({ show: false });
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function removeUserBrouillonDialog(brouillon) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer le brouillon`,
        description: `Voulez vous supprimer le brouillon ${brouillon.client_nom} ?`,
        actionName: 'Supprimer',
        btnVariant: 'danger',
        element: brouillon._id,
        error: false,
        confirmAction: 'removeUserBrouillon'
      }
    })
  }

  function removeOtherBrouillon(brouillonId) {
    BrouillonService.removeBrouillon(folderDetails?.dossier?._id, brouillonId).then(res => {
      getOtherBrouillons()
      setConfirmDialog({ show: false });
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function removeOtherBrouillonDialog(brouillon) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer le brouillon`,
        description: `Voulez vous supprimer le brouillon ${brouillon.client_nom} ?`,
        actionName: 'Supprimer',
        btnVariant: 'danger',
        element: brouillon._id,
        error: false,
        confirmAction: 'removeOtherBrouillon'
      }
    })
  }

  function changePaginationUser(p) {
    setCurrentUserPagination(p)
    brouillonsUserParams.current['start'] = (brouillonsUserParams.current.limit * p) - brouillonsUserParams.current.limit
    getUserBrouillons()
  }

  function changePaginationOther(p) {
    setCurrentOtherPagination(p)
    brouillonsOtherParams.current['start'] = (brouillonsOtherParams.current.limit * p) - brouillonsOtherParams.current.limit
    getOtherBrouillons()
  }

  return (
    <>

      <ErrorManager error={globalError} fixed="true" />

      <ConfirmDialog
        show={confirmDialog.show}
        dialogInfos={confirmDialog.dialogInfos}
        setCancel={() => setConfirmDialog({ show: false })}
        setConfirm={(a, e) => eval(a)(e)}
      />

      <>
        {((brouillonsUser || brouillonsOther) && granted(grants, "brouillons.consult")) &&
          <Dropdown className="d-inline-block me-2" align="end">
            <Dropdown.Toggle variant="dark" id="dropdown-selectionnes">
              Brouillon(s) en cours
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: 'max-content' }}>

              {/* Brouillons de l'utilisateur connecté */}
              {(granted(grants, "brouillons.consult") && brouillonsUser && (brouillonsUser?.brouillons.filter(b => b.user == userDetails.preferred_username).length > 0)) &&
                <>
                  <h6 className="ps-3 pt-2">Mes brouillons ({brouillonsUser?.total})</h6>
                  {brouillonsUser?.brouillons.filter(b => b.user == userDetails.preferred_username).sort(function (a, b) { return new Date(b.date) - new Date(a.date) }).map((brouillon, i) => (
                    <Dropdown.ItemText key={brouillon._id} className="d-flex">
                      <Button variant="secondary" disabled={!granted(grants, "brouillons.edit")} onClick={() => granted(grants, "brouillons.edit") && openBrouillon(brouillon._id)} className="w-100 text-start d-flex align-items-center">
                        <span className="fw-bold me-1">{new Date(brouillon.date).toLocaleString()} : </span>
                        <span className="me-4">{brouillon.client_nom || "(Aucun client sélectionné)"}</span>
                        <Badge bg="gray-200" text="dark" className="ms-auto">{brouillon.type}</Badge>
                      </Button>
                      {granted(grants, "brouillons.remove") &&
                        <Button variant="outline-danger" className="ms-2" onClick={() => removeUserBrouillonDialog(brouillon)}>Supprimer</Button>
                      }
                    </Dropdown.ItemText>
                  ))}
                  <div className="ps-3 mb-3">
                    <Pagination className="mt-3" itemsLength={brouillonsUser?.total} elementsPerPage={brouillonsUserParams.current.limit} currentPagination={currentUserPagination} changePagination={p => changePaginationUser(p)} />
                  </div>
                </>
              }

              {/* Brouillons des autres utilisateurs */}
              {(granted(grants, "brouillons.consult.brouillons_tiers") && brouillonsOther && (brouillonsOther?.brouillons.filter(b => b.user != userDetails.preferred_username).length > 0)) &&
                <>
                  <h6 className="ps-3 pt-2">Brouillons des autres utilisateurs ({brouillonsOther?.total})</h6>
                  {brouillonsOther?.brouillons.filter(b => b.user != userDetails.preferred_username).sort(function (a, b) { return new Date(b.date) - new Date(a.date) }).map((brouillon, i) => (
                    <Dropdown.ItemText key={brouillon._id} className="d-flex align-items-start">
                      <Button variant="secondary" disabled={!granted(grants, "brouillons.edit.brouillons_tiers")} onClick={() => openBrouillon(brouillon._id)} className="w-100 d-flex flex-column">
                        <div className="d-flex w-100 align-items-center">
                          <span className="fw-bold me-1">{new Date(brouillon.date).toLocaleString()} : </span>
                          <span className="me-4">{brouillon.client_nom || "(Aucun client sélectionné)"}</span>
                          <Badge bg="gray-200" text="dark" className="ms-auto">{brouillon.type}</Badge>
                        </div>
                        <small className="text-start">Crée par {brouillon.user || "-"}</small>
                      </Button>
                      {granted(grants, "brouillons.edit.brouillons_tiers") &&
                        <Button variant="outline-danger" className="ms-2" onClick={() => removeOtherBrouillonDialog(brouillon)}>Supprimer</Button>
                      }
                    </Dropdown.ItemText>
                  ))}
                  <div className="ps-3 mb-3">
                    <Pagination className="mt-3" itemsLength={brouillonsOther?.total} elementsPerPage={brouillonsOtherParams.current.limit} currentPagination={currentOtherPagination} changePagination={p => changePaginationOther(p)} />
                  </div>
                </>
              }

            </Dropdown.Menu>
          </Dropdown>
        }
      </>

    </>

  );

}

export default Brouillons;